import styled from "styled-components";

export const GallerySection = styled.div`
    background: #f4f5f7;
    padding: 8rem 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const GalleryTitle = styled.h2`
    font-size: 3.5rem;
    font-weight: 700;
    margin-bottom: 4rem;
    color: #000;
    
    @media (max-width: 768px) {
        font-size: 2.8rem;
    }
`;

export const GridContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 2rem;
    width: 100%;
    max-width: 1200px;
`;

export const CategoryCard = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 10px;
    cursor: pointer;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease;
    height: 250px;

    &:hover {
        transform: translateY(-5px);
        
        div {
            background: rgba(0, 0, 0, 0.7);
        }
        
        img {
            transform: scale(1.1);
        }
    }
`;

export const CategoryImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s ease;
`;

export const CategoryOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.3s ease;
    padding: 2rem;
    text-align: center;
`;

export const CategoryLabel = styled.h3`
    color: #fff;
    font-size: 2rem;
    font-weight: 600;
    letter-spacing: 1px;
    margin: 0;
`;

export const ModalImageGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1.5rem;
    padding: 1rem;
`;

export const ModalImage = styled.img`
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
`;
